<template lang="pug">
  b-container(fluid class="container-fluid-custom bg-greylight")
    maintenance

</template>

<script>
import Maintenance from '@/components/templates/Maintenance'

export default {
  name: 'PageMaintenance',
  components: {
    Maintenance
  }
}
</script>



// WEBPACK FOOTER //
// src/components/widgets/PageMaintenance.vue